// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* don't use colors.css and friends as the theme system is not set up when this is used */

.invalid-embed_container__D38u {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;

    /* this is an error, so we want it to stand out and always be readable regardless of what the site */
    /* embedding us looks like */
    background-color: #ff4c4c;
    color: white;

    box-sizing: border-box;
    padding: 8px;

    display: flex;
    flex-direction: column;
    gap: 12px;
}

.invalid-embed_code_uWpWU {
    font-family: monospace;
}

.invalid-embed_emphasis_YbMO6 {
    text-decoration: underline;
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-invalid-embed/invalid-embed.css"],"names":[],"mappings":"AAAA,yFAAyF;;AAEzF;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,cAAc;;IAEd,oGAAoG;IACpG,4BAA4B;IAC5B,yBAAyB;IACzB,YAAY;;IAEZ,sBAAsB;IACtB,YAAY;;IAEZ,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB","sourcesContent":["/* don't use colors.css and friends as the theme system is not set up when this is used */\n\n.container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n\n    /* this is an error, so we want it to stand out and always be readable regardless of what the site */\n    /* embedding us looks like */\n    background-color: #ff4c4c;\n    color: white;\n\n    box-sizing: border-box;\n    padding: 8px;\n\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.code {\n    font-family: monospace;\n}\n\n.emphasis {\n    text-decoration: underline;\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `invalid-embed_container__D38u`;
export var code = `invalid-embed_code_uWpWU`;
export var emphasis = `invalid-embed_emphasis_YbMO6`;
export default ___CSS_LOADER_EXPORT___;
